"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrimmerCanvas = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

require("./TrimmerControls.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Constants
var TRACK_HEIGHT = 48.0;
var TRACK_WIDTH = 256.0;
var SIDE_HANDLE_WIDTH = 32.0; // Trimmer

var TrimmerCanvas = function TrimmerCanvas(_ref) {
  var frames = _ref.frames;
  // const [framesDrawn, setFramesDrawn] = useState([])
  // Once we have the frames, draw them to the canvas
  (0, _react.useEffect)(function () {
    if (frames && frames.length > 0) {
      (function () {
        var track = document.querySelector("#trimmer-track-images");
        if (!track.canvasExists) track.height = TRACK_HEIGHT;
        if (!track.canvasExists) track.width = TRACK_WIDTH + 2 * SIDE_HANDLE_WIDTH;
        if (!track.canvasExists) track.style.borderRadius = "var(--spacing)";
        track.canvasExists = 'true';
        var trackContext = track.getContext("2d");

        var _loop = function _loop(i) {
          // if (framesDrawn.includes(i)) { continue }
          var frame = frames[i];
          var drawing = new Image();

          drawing.onload = function () {
            trackContext.drawImage(drawing, i * TRACK_HEIGHT, 0, TRACK_HEIGHT, TRACK_HEIGHT);
          };

          drawing.onerror = function (err) {
            console.log("err drawing frame onto context", err);
          };

          drawing.src = frame; // let newFramesDrawn = [...framesDrawn]
          // newFramesDrawn.push(i)
          // setFramesDrawn(newFramesDrawn)
        };

        for (var i = 0; i < frames.length; i++) {
          _loop(i);
        }
      })();
    }
  }, [frames]);
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "TrimmerCanvas"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "canvas-container"
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    id: "trimmer-track-images"
  }))));
};

exports.TrimmerCanvas = TrimmerCanvas;